export default "__VITE_ASSET__ByR95KfJ__"